
import { gizmoRuntime } from '@gizmo/runtime';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Component from './component';
import './main.css';

// Workaround for compiling tsx->js calling out to unknown "React" symbol
window.React = React;
window.gizmoRuntime = gizmoRuntime;

class App extends React.Component {
  render() {
    return <Component />;
  }
}

const root = ReactDOM.createRoot(document.getElementById('application'));
root.render(<App />);
